import './PlayerStatus.styles.css';

import { FC, useMemo } from 'react';

import commonStore from '../../../store/CommonStore';
import { formatNumber } from '../../Game/table.render.utils';
import { PlayerStatusProps } from './PlayersStatus.types';

const PlayerStatus: FC<PlayerStatusProps> = ({ stack, sittingOut, allIn }) => {
  const content = useMemo(() => {
    if (sittingOut) {
      return <div className="player-sitting-out">Sitting Out</div>;
    } else if (allIn) {
      return <div className="player-allin">All In</div>;
    } else {
      return (
        <div className="player-stack">
          {formatNumber(stack)}
          {commonStore.getIsChipsConvertedToBlinds() && (
            <span className="bb-text">{' BB'}</span>
          )}
        </div>
      );
    }
  }, [stack, sittingOut, allIn, commonStore.getIsChipsConvertedToBlinds()]);

  return <div>{content}</div>;
};

export default PlayerStatus;
